var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBoxIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#A4ADB4",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M33 10.5 18 3 3 10.5v15L18 33l15-7.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#A4ADB4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M3 10.5 18 18m0 15V18m15-7.5L18 18m7.5-11.25-15 7.5"
})));
export default SvgBoxIcon;